/*
  The top of the home page, laid out like the events storefront's home (Robert, 2026-10-20:
  "make the top the same layout as the events. But just have one still image instead of
  multiple"): the banner artwork in a rounded panel on the left, the Population Report card
  standing beside it on the right. Where the storefront rotates a carousel of slides, this is
  the one still image, with no dots.

  It replaces the full-width black banner band (HeroBanner) and the cert lookup + card row
  under it (HomeHero). The cert lookup now sits under this, beside the population search,
  in HomeView.

  **The image fills the panel, however tall the card is.** It is absolutely positioned with
  `object-cover`, so the panel takes the card's height (the grid row stretches both) and the
  artwork is cropped to fit. The artwork (Robert's "Population Report" PDF, 2026-10-20,
  rasterised to 2400x1000) is 2.4:1, wider than the panel ever gets (about 1.4:1 at 1366,
  2.3:1 at 1920, 1.6:1 on a phone), so the crop only ever trims the sides and the full
  height always shows. Its logo, title, gold strap and office list sit in the middle 40% of
  its width, which every one of those crops keeps. Its own black fade at the bottom is kept.

  **Dark in both themes, on purpose.** The artwork is a photograph, so the panel behind it is
  a literal black that matches its fade; in the white light mode it reads as a dark picture on
  a white page, beside a light card.

  **As wide as the home page's content**, which Layout widens on home to run out to 4.5rem
  from each screen edge (up to 1760px), like the storefront. On a wide screen that is what
  keeps the artwork's lettering from crowding the panel.

  Below `lg` the two stack, image first, and the panel takes a fixed height. If the card has
  nothing to show (an error, or a /counts payload that fails statsBandState's guard), the
  image takes the whole row.

  The page's h1 stays in HomeView. The image's lettering is not text a screen reader can
  read, so it carries the alt text instead.
*/

import bannerUrl from 'images/population-report-banner.webp';
import PopulationCard, { usePopulationStats } from 'components/PopulationCard';
import { HERO_IMG } from 'components/styles';

const HomeShowcase = () => {
  const stats = usePopulationStats();

  return (
    <div
      className={`grid gap-6 ${
        stats.visible ? 'lg:grid-cols-[minmax(0,1fr)_minmax(340px,400px)]' : ''
      }`}
    >
      <div className="relative h-[clamp(220px,52vw,340px)] overflow-hidden rounded-2xl bg-black shadow-lg lg:h-auto lg:min-h-[420px]">
        <img
          src={bannerUrl}
          alt="PCG Population Report: live global PCG statistics"
          width={2400}
          height={1000}
          decoding="async"
          {...HERO_IMG}
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
      </div>
      {stats.visible ? <PopulationCard stats={stats} /> : null}
    </div>
  );
};

export default HomeShowcase;
